import type { IConfig } from '#/shared/stores/configs';

import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Form } from 'semantic-ui-react';

import SSMForm from '#/shared/forms/_.extend';
import { useStoreItem } from '#/shared/hooks/useStoreItem';

import FormControls from './controls/FormControls';

const AuthFormLogin = observer(({ form }: { form: SSMForm }) => {
  const {
    item: { configData },
  } = useStoreItem<
    | {
        configData: {
          portal?: boolean;
        };
        name: 'magicLink';
      }
    | IConfig,
    IConfig['name']
  >({
    opts: {
      query: { $client: { public: true } },
      reload: true,
    },
    storeName: 'configs',
    uuid: 'magicLink',
  });

  const [visiblePassword, setVisiblePassword] = useState(false);

  const email = form.$('email').value;

  return (
    <Form>
      <form.Field fieldKey="email" type="email" />
      <div className="w-100 flex justify-between">
        <form.Field
          autoComplete="off"
          fieldKey="password"
          icon={{
            className: 'pointer',
            color: visiblePassword ? 'blue' : 'grey',
            link: true,
            name: visiblePassword ? 'eye' : 'eye slash',
            onClick: () => setVisiblePassword(!visiblePassword),
          }}
          type={visiblePassword ? 'text' : 'password'}
        />
      </div>
      <FormControls
        controls={{
          magicLink: configData?.portal ?? /shiftsmart\.com$/i.test(email),
          onSubmit: true,
        }}
        form={form}
        labels={{
          submit: 'Login',
        }}
      />
      <p className="red">{form.error}</p>
    </Form>
  );
});

export default AuthFormLogin;
